import { render, staticRenderFns } from "./footerbox.vue?vue&type=template&id=7757da38&scoped=true"
import script from "./footerbox.vue?vue&type=script&lang=js"
export * from "./footerbox.vue?vue&type=script&lang=js"
import style0 from "./footerbox.vue?vue&type=style&index=0&id=7757da38&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7757da38",
  null
  
)

export default component.exports